<template>
  <div v-if="isCurrency" class="l-container">
    <ModelOffers
      class="l-description-grid"
      :model="pageData.model"
      :offer-filters="pageData.filters"
      :offers="pageData.offers"
      :per-page="10"
      :changed-page="pageData.changedPage"
      show-all
      @set-filter="(e) => $emit('set-filter', e)"
      @change-data="(e) => $emit('change-data', e)"
      @change-model-sort-top3="$emit('change-model-sort-top3')"
      @to-route="(e) => $emit('toRoute', e)"
      @open-monitoring-sticker-modal="
        (e) => $emit('openMonitoringStickerModal', e)
      "
    />
  </div>
  <div v-if="monitoring" class="l-container l-description-grid">
    <LazyPageModelMonitoringModel
      :monitoring="monitoring"
      @open="$emit('openMonitoringModal')"
      @open-how="$emit('openHowMonitoringModal')"
    />
  </div>
  <div v-if="monitoring && isBot" class="l-container l-description-grid">
    <LazyModalsMonitoringModalBlock
      :offers="monitoring?.offers || []"
      :monitoring="monitoring"
    />
  </div>
  <div v-if="showWg" class="l-container l-description-grid">
    <h2 class="header heading-m title">Рекомендуем также</h2>
    <Script type="text/javascript">
      (function (params) { var s = document.createElement('script'); s.type =
      'text/javascript'; s.async = true; s.src =
      'https://wg4.price.ru/partners/js/app.js'; s.setAttribute('options',
      JSON.stringify(params)); document.currentScript.parentNode.insertBefore(
      s, document.currentScript ); })({ search_query: window.wgdata.search,
      region_id: window.wgdata.region, utm_campaign: 'model_price', block_type:
      "", partner_pad_id: "321444802", category_id: window.wgdata.category_id,
      price: window.wgdata.price });
    </Script>
  </div>
  <div
    v-if="!pageData.model?.offer_count && isCurrency"
    class="l-container l-description-grid"
  >
    <ModelSimilar
      :similar="pageData.similaruserlike || []"
      type="similaruserlike"
      title="Пользователям нравится среди похожих"
      :model-id="pageData.model.id"
      :changed-page="pageData.changedPage"
      :page-data="pageData"
      full-width-mobile
      @change-data="(e) => $emit('change-data', e)"
    />
  </div>
  <div class="l-container">
    <div class="l-description-grid chart-wrapper">
      <div class="base-tab price-chart">
        <UiPriceChart
          :is-collapsed="!isMobile"
          :page-data="pageData"
          @change-data="(e) => $emit('change-data', e)"
          @to-route="(e) => $emit('toRoute', e)"
          @component-hide="(e) => $emit('hideComponent', e)"
        />
      </div>
      <div id="description-model" class="description">
        <PageModelDescriptionModel :seo-data="seoData" />
      </div>
      <div class="characteristics">
        <PageModelModelCharacteristics
          :model-id="pageData.model.id"
          :name="pageData.model.name"
          :brand="pageData.model.brand"
          :category="props.pageData.model.category"
          :spec="pageData.specifications"
          :show-all="isBot"
          :is-tab="false"
          class="content-block characteristics"
          @to-route="(e) => $emit('toRoute', e)"
        />
      </div>
    </div>
  </div>

  <div id="model-similar" class="l-container l-description-grid">
    <ModelSimilar
      :similar="pageData.similar || []"
      :model-id="pageData.model.id"
      :changed-page="pageData.changedPage"
      :page-data="pageData"
      :title="isCurrency ? 'Похожие товары' : 'ПОПУЛЯРНОЕ СРЕДИ ПОХОЖИХ'"
      type="similar"
      full-width-mobile
      @change-data="(e) => $emit('change-data', e)"
    />
  </div>
  <div id="add_review" />
  <div ref="otzyvybasetab" class="l-container l-description-grid">
    <PageModelModelReviews
      :model="pageData.model"
      :page-data="pageData"
      :otzyvy="pageData.otzyvy"
      :pictures="pageData.pictures"
      :changed-page="pageData.changedPage"
      :per-page="20"
      is-base-tab
      :wide-pagination="false"
      when-visible
      @to-route="(e) => $emit('toRoute', e)"
      @change-data="(e) => $emit('change-data', e)"
    />
  </div>
  <div ref="questionsbasetab" class="l-container l-description-grid">
    <PageModelModelQuestions
      :model="pageData.model"
      :page-data="pageData"
      :changed-page="pageData.changedPage"
      :per-page="20"
      :is-base-tab="true"
      :wide-pagination="false"
      when-visible
      @to-route="(e) => $emit('toRoute', e)"
      @change-data="(e) => $emit('change-data', e)"
    />
  </div>
  <div v-if="pageData?.videos?.length" class="l-container l-description-grid">
    <PageModelModelVideos
      :videos="pageData.videos"
      :changed-page="pageData.model.changedPage"
      class="content-block videos"
      @to-route="(e) => $emit('toRoute', e)"
    />
  </div>

  <div class="l-container">
    <ModelHistoryImport :no-padding="true" />
  </div>

  <div v-if="isCurrency" class="l-container l-description-grid">
    <BlogArticlesImport
      type="model"
      :articles="pageData.articles"
      :model="pageData.model"
      class="l-description-grid"
      full-width-mobile
      @change-data="(e) => $emit('change-data', e)"
    />
  </div>

  <div v-if="isCurrency" class="l-container l-description-grid">
    <ModelSimilar
      :similar="pageData?.model?.accessories"
      title="Аксессуары"
      type="accessories"
      :show-more-button="false"
      :is-accessories="true"
      :model-id="pageData.model.id"
      :page-data="pageData"
      :changed-page="pageData.changedPage"
      full-width-mobile
      @change-data="(e) => $emit('change-data', e)"
    />
  </div>
  <div v-if="isCurrency" class="l-container l-description-grid">
    <ModelSimilar
      title="Другие товары категории"
      :similar="pageData.similar || []"
      :item-count="12"
      :model-id="pageData.model.id"
      :changed-page="pageData.changedPage"
      :page-data="pageData"
      type="other"
      full-width-mobile
      @change-data="(e) => $emit('change-data', e)"
    />
  </div>
  <div class="l-container l-description-grid">
    <PresetsBasic
      v-if="isPresets"
      title="Популярные подборки"
      :items="pageData.presets"
      mobile-full-view
    />
  </div>
</template>
<script setup lang="ts">
import type { ModelPriceMonitoringType } from '~/interfaces/api';

const BlogArticlesImport = defineAsyncComponent(
  () => import('~/components/blog-articles/BlogArticles.vue')
);
const ModelHistoryImport = defineAsyncComponent(
  () => import('~/components/model-history/ModelHistory.vue')
);
defineEmits([
  'change-data',
  'change-model-sort-top3',
  'toRoute',
  'hideComponent',
  'set-filter',
  'openMonitoringModal',
  'openHowMonitoringModal',
  'openMonitoringStickerModal',
]);
const props = defineProps({
  isMobile: {
    type: Boolean,
    default: false,
  },
  isTablet: {
    type: Boolean,
    default: false,
  },
  isBot: {
    type: Boolean,
    default: false,
  },
  isPresets: {
    type: Boolean,
    default: false,
  },
  isGoToReview: {
    type: Boolean,
    default: false,
  },
  pageData: {
    type: Object as any,
    required: true,
  },
  seoData: {
    type: Object as any,
    required: true,
  },
  isCurrency: {
    type: Boolean,
    default: false,
  },
  monitoring: {
    type: [String, Object] as PropType<ModelPriceMonitoringType | string>,
    required: true,
  },
});
const showWg = ref(false);
const otzyvybasetab = ref();
const isCurrency = computed<boolean>(() => {
  return (
    props.pageData?.model?.price_info &&
    props.pageData?.model?.offer_count &&
    !!(
      props.pageData?.model?.price_info.min ||
      props.pageData?.model?.price_info.max
    )
  );
});
onBeforeMount(() => {
  if (window && props.seoData && isCurrency.value) {
    try {
      const search = props.seoData.page.breadcrumbs[3].nav.filter(
        (i: any) => i.title !== props.seoData.page.breadcrumbs[3].title
      )[0].title;
      window.wgdata = {
        search,
        region: props.seoData?.region?.id,
        category_id: props.seoData.page.context.category_id,
        price: {
          min: props.pageData?.model?.price_info.min || 0,
          max: props.pageData?.model?.price_info.max || 0,
        },
      };
      setTimeout(() => {
        showWg.value = true;
      }, 300);
    } catch (e) {
      console.error('wg error', e);
    }
  }
});

watch(
  () => props.isGoToReview,
  () => {
    if (props.isGoToReview) {
      nextTick(() =>
        setTimeout(() => {
          otzyvybasetab.value.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
          });
        }, 1000)
      );
    }
  }
);
onMounted(() => {
  setTimeout(() => {
    const wg = document.querySelector('.wg-partners-4');
    // убрать заголовок, если не появился виджет
    if (showWg.value && !wg) {
      showWg.value = false;
    }
  }, 3000);
});
</script>
<style lang="scss" scoped>
.chart-wrapper {
  display: flex;
  flex-direction: column;
  gap: 20px;
  @include md-block {
    gap: 24px;
  }
  @include lg-block {
    display: grid;
    column-gap: 56px;
    row-gap: 32px;
    grid-template-areas:
      'a b'
      'c b';
    grid-template-columns: 16fr 7fr;
    grid-template-rows: 1fr auto;
  }
  @include xl-block {
    column-gap: 66px;
  }
  @include xxl-block {
    column-gap: 80px;
  }

  .description {
    grid-area: a;
  }

  .price-chart {
    grid-area: b;
    width: 100%;
    margin-bottom: 20px;
    @include lg-block {
      margin-bottom: 24px;
    }
    @include lg-block {
      margin-bottom: 0;
    }
  }

  .characteristics {
    grid-area: c;
  }

  .base-tab {
    padding-top: 0;
  }
}
:deep(.blog-articles) {
  margin-top: 40px;
  @include md-block {
    margin-top: 48px;
  }
  @include lg-block {
    margin-top: 64px;
  }
}
.title {
  margin-bottom: 16px;
  @include xl-block {
    margin-bottom: 20px;
  }
}
</style>
